import { jsx as _jsx } from "react/jsx-runtime";
import { twMerge } from 'tailwind-merge';
import { useTheme } from '../../';
export const SidebarItems = ({ children, className, ...props }) => {
    const theme = useTheme().theme.sidebar.items;
    return (_jsx("div", { className: twMerge(theme, className), "data-testid": "flowbite-sidebar-items", ...props, children: children }));
};
SidebarItems.displayName = 'Sidebar.Items';
